<div class="d-flex flex-column h-100 gap-3">
  <!-- Fixed form at top -->
  <div class="row gy-3">
    <div class="col-lg-4 col-md-6 col-xxl-3">
      <generic-dropdown
        [items]="projects()"
        label="Project"
        placeholder="Select project"
        [clearable]="true"
        [allowSearch]="true"
        [ngModel]="selectedProjectId()"
        (ngModelChange)="selectedProjectId.set($event)"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
  </div>
  @if (selectedProjectId()) {
    <form [formGroup]="form">
      <div class="form-section sticky-top bg-white rounded-3 p-3 shadow-sm">
        <div class="row gy-3">
          <!-- <div class="col-lg-3 col-md-6">
            <generic-dropdown
              [items]="tasks()"
              label="Task"
              placeholder="Select task"
              [allowSearch]="true"
              [clearable]="true"
              formControlName="taskId"
            />
          </div> -->
          <div class="col-lg-2 col-md-6">
            <input-field
              label="Offset (Calendar days)"
              type="number"
              placeholder="0"
              [requiredLabel]="true"
              formControlName="offsetBusinessDays"
              [min]="0"
            />
          </div>
          <div class="col-lg-auto col-md-6">
            <currency-input-field
              label="Amount"
              placeholder="Amount"
              [requiredLabel]="true"
              formControlName="amount"
              [control]="form.get('amount')"
            />
          </div>
          <!-- <div class="col-md-2">
          <input-field label="Sort order" type="number" placeholder="0" [requiredLabel]="true"
            formControlName="sortOrder" [min]="0" />
        </div> -->
          <div class="col-auto d-flex gap-2 align-self-end ms-auto ms-lg-0">
            @if (selectedRowId()) {
              <button type="button" class="btn btn-shadow btn-h42" (click)="clearSelection()">Cancel</button>
            }
            <button
              type="button"
              class="btn btn-primary btn-h42"
              [disabled]="form.invalid || isSaving()"
              (click)="onSave()"
            >
              {{ selectedRowId() ? 'Update' : 'Add' }}
            </button>
          </div>
        </div>
      </div>
    </form>
  }

  <!-- Existing records table -->
  <div class="table-section flex-fill overflow-auto">
    @if (!selectedProjectId()) {
      <div class="bg-white p-3 rounded-3 h-100 d-flex flex-column align-items-center justify-content-center">
        <i class="bi bi-folder text-muted fs-48"></i>
        <p class="text-muted mb-0 fw-500 fs-18">Select a project to view and manage deposit schedules.</p>
      </div>
    } @else {
      <div class="table-outer table-theme">
        <div class="table-responsive h-100">
          <p-table [value]="deposits()">
            <ng-template pTemplate="header">
              <tr>
                <!-- <th>Task</th> -->
                <th pSortableColumn="offsetBusinessDays">
                  Offset (Calendar days) <p-sortIcon field="offsetBusinessDays" />
                </th>
                <th pSortableColumn="amount">Amount <p-sortIcon field="amount" /></th>
                <!-- <th>Sort order</th> -->
                <th class="text-end" style="width: 120px">Actions</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <!-- <td>{{ row.taskName }}</td> -->
                <td>{{ row.offsetBusinessDays ?? '-' }}</td>
                <td>{{ row.amount | currencyFormat }}</td>
                <!-- <td>{{ row.sortOrder ?? '-' }}</td> -->
                <td class="text-center align-baseline bg-inherit" alignFrozen="right" pFrozenColumn [frozen]="true">
                  <div ngbDropdown container="body">
                    <i class="bi bi-three-dots-vertical" ngbDropdownToggle></i>
                    <div ngbDropdownMenu>
                      <button ngbDropdownItem (click)="onEditRow(row)">Edit</button>
                      <button class="text-danger" ngbDropdownItem (click)="confirmDepositDelete(row)">Delete</button>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" class="text-center text-danger py-4">
                  No deposit schedules found. Use the form above to add one.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    }
  </div>
</div>

<app-confirm-popup (onConfirm)="onConfirmDelete(selectedRowId)"></app-confirm-popup>
